import React from 'react'
import divideImg from '../../assets/productDivider.svg'
import * as styles from './details.module.css'

export const MobileDivider = () => {
  return (
    <div className={styles.mobiledivider} id="currentArrow">
      <img src={divideImg} alt="" id="currentItemIcon" />
    </div>
  )
}
